import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

const EditEventModal = ({ show, onHide, event, onSave, rehearsals = [] }) => {
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (event) {
            setName(event.name);
            // Convert ISO date to the format expected by datetime-local input
            const localDate = new Date(event.date);
            const year = localDate.getFullYear();
            const month = (localDate.getMonth() + 1).toString().padStart(2, '0');
            const day = localDate.getDate().toString().padStart(2, '0');
            const hours = localDate.getHours().toString().padStart(2, '0');
            const minutes = localDate.getMinutes().toString().padStart(2, '0');
            setDate(`${year}-${month}-${day}T${hours}:${minutes}`);
        }
        setError(''); // Reset error when modal is shown or event changes
    }, [event, show]);

    const handleSave = () => {
        setError(''); // Clear previous errors
        const newEventDate = new Date(date);

        if (rehearsals && rehearsals.length > 0) {
            const latestRehearsal = rehearsals.reduce((latest, current) => {
                const latestDate = new Date(latest.date);
                const currentDate = new Date(current.date);
                return currentDate > latestDate ? current : latest;
            });

            if (newEventDate < new Date(latestRehearsal.date)) {
                const latestRehearsalDateFormatted = new Date(latestRehearsal.date).toLocaleString();
                setError(`Дата события не может быть раньше последней репетиции (${latestRehearsalDateFormatted}).`);
                return; // Stop the save
            }
        }

        onSave({
            name,
            date: newEventDate.toISOString(),
        });
    };

    const handleDateChange = (e) => {
        setDate(e.target.value);
        if (error) {
            setError(''); // Clear error when user starts fixing the date
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Редактировать событие</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form>
                    <Form.Group className="mb-3" controlId="eventName">
                        <Form.Label>Название события</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="eventDate">
                        <Form.Label>Дата и время</Form.Label>
                        <Form.Control
                            type="datetime-local"
                            value={date}
                            onChange={handleDateChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Отмена
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Сохранить
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditEventModal;